import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const SurveyApi = {
    getSurveys,
    getSurvey,
    createSurvey,
    updateSurvey,
    deleteSurvey,
    getResponses,
    deleteResponse,
    getSummary,
    exportCsv,
}

async function getSurveys({ params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/surveys`, { params });
}

async function getSurvey({ id }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/surveys/${id}`);
}

async function createSurvey({ body }) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/surveys`, body);
}

async function updateSurvey({ id, body }) {
    return await authAxios.patch(`${MAIN_API_HOST}/v2/public/surveys/${id}`, body);
}

async function deleteSurvey({ id }) {
    return await authAxios.delete(`${MAIN_API_HOST}/v2/public/surveys/${id}`);
}

// 개별 응답 (최신순)
async function getResponses({ id, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/surveys/${id}/responses`, { params });
}

async function deleteResponse({ id, responseId }) {
    return await authAxios.delete(`${MAIN_API_HOST}/v2/public/surveys/${id}/responses/${responseId}`);
}

// 질문별 요약
async function getSummary({ id }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/surveys/${id}/summary`);
}

// 전체 응답 CSV (파일 내용 그대로)
async function exportCsv({ id }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/surveys/${id}/export`, { responseType: 'blob' });
}
